module.exports = __webpack_public_path__ + "img/erweima.1a8b8004.png";